import { apiService } from "../../services/apiService";
import { apiServiceConstants } from "../../constants";
import { utilService } from "../../services/utilService";
import { doctorsListService } from "../../components/Shared/DoctorList/doctor-list-service";

const getSelectedMsgUserListData = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/group-sms-user-list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const userListResponse = doctorsListService.setDoctorListModel(
        userListResp.result
      );
      const result: any = {
        isSuccess: true,
        result: userListResponse,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const setReplyData = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/connect/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        result: userListResp.result,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getMessagedUserListData = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/messages-reply-user/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const userListResponse = doctorsListService.setDoctorListModel(
        userListResp.result
      );
      const result: any = {
        isSuccess: true,
        result: userListResponse,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const setReplyAllData = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/group-sms/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        result: userListResp.result,
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const handleErrorResponse = () => {};

export const userMessageService = {
  handleErrorResponse,
  getSelectedMsgUserListData,
  setReplyData,
  setReplyAllData,
  getMessagedUserListData,
};
